import { createStyles } from '@material-ui/styles';

export default (overrideClasses?: any) =>
  createStyles({
    switchContainer: {
      padding: '0 0 15px 15px',
    },
    ...overrideClasses,
  });
